import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SpanEditing from './spanediting';

export default class SpecialSpan extends Plugin {
  static get requires() {
    return [ SpanEditing ];
  }

  static get pluginName() {
    return 'Span';
  }
}
